const flatStaffHierarchyTransformer = response => {
  return response?.map(item => {
    return {
      ...item,
      id: item?.userId.toString(),
    }
  })
}

export default flatStaffHierarchyTransformer
